document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.ps-case-studies-wrapper').forEach(wrapper => {

        const listing = wrapper.querySelector('.ps-case-studies-listing');
        const button = wrapper.querySelector('.ps-load-more-btn');

        let paged = 2; // PHP already loaded page 1
        let loading = false;

        const perDesktop = parseInt(wrapper.dataset.loadDesktop);
        const perMobile = parseInt(wrapper.dataset.loadMobile);
        const includeCat = wrapper.dataset.include;
        const excludeCat = wrapper.dataset.exclude;

        function isMobile() { return window.innerWidth <= 960; }
        function getPerPage() { return isMobile() ? perMobile : perDesktop; }

        button.addEventListener('click', () => {
            if (loading) return;
            loading = true;
            button.classList.add('loading');

            const url = `${ps_rest.origin}/wp-json/ps/v1/case-studies?paged=${paged}&per_page=${getPerPage()}&include_cat=${includeCat}&exclude_cat=${excludeCat}`;

            fetch(url)
                .then(res => res.json())
                .then(data => {
                    data.posts.forEach(post => {
                        listing.insertAdjacentHTML('beforeend', `
                            <div class="ps-case-studies-item visible">
                                <a href="${post.link}" class="ps-case-studies-link">
                                    <div class="ps-case-studies-image">
                                        ${post.image ? `<img src="${post.image}" alt="${post.title}">` : ''}
                                    </div>
                                    <h2 class="ps-case-studies-title">${post.title}</h2>
                                    <p class="ps-case-studies-excerpt">${post.excerpt}</p>
                                </a>
                            </div>
                        `);
                    });

                    if (!data.has_more) button.style.display = 'none';
                    paged++;
                    loading = false;
                    button.classList.remove('loading');
                })
                .catch(err => {
                    console.error(err);
                    button.style.display = 'none';
                });
        });

    });
});